<script setup lang="ts">
type Props = {
  name: string;
  tag?: string;
};

const { tag = 'div' } = defineProps<Props>();
</script>

<template>
  <component
    :is="tag || 'div'"
    :id="name"
  />
</template>

<style scoped></style>

<i18n lang="json">{}</i18n>
